/**
 * navigate.js — SPA navigation helper for the custom path-based router in App.jsx.
 *
 * App.jsx tracks window.location.pathname in state and re-renders on 'popstate'.
 * navTo() pushes a new history entry and fires 'popstate' so the router swaps the
 * page component without a full page reload.
 */
export function navTo(path) {
  if (window.location.pathname === path) return;
  window.history.pushState({}, '', path);
  window.dispatchEvent(new Event('popstate'));
}

const _IS_EXTENSION = typeof window !== 'undefined' &&
  (window.__AIMAIL_IS_EXTENSION || window.__AIMAIL_FORCE_COMPACT ||
   import.meta.env.VITE_IS_EXTENSION === 'true');

// In the Chrome extension build there is no in-app pricing route — the side
// panel only bundles the AIMail page. Send users to the hosted web pricing.
export const PRICING_HREF = _IS_EXTENSION
  ? 'https://personadraft.com/pricing'
  : '/pricing';

export function openPricing(e) {
  if (e && typeof e.preventDefault === 'function') e.preventDefault();
  if (_IS_EXTENSION) {
    window.open('https://personadraft.com/pricing', '_blank', 'noopener,noreferrer');
  } else {
    navTo('/pricing');
  }
}
